<template>
    <div id="shipping-wrap">
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Delivery Date:</div>
            <div class="col-md-9">
                <div class="form-control" ref="delivery_date">
                    <date-picker value-type="format" v-model="model.delivery_date" :disabled-date="(date) => date <= disabledBefore || date > disabledMaxDate" :default-value="disabledBefore" :disabled="po_by_car"></date-picker>
                </div>
                <p v-if="backorder" class="backorder_msg">Purchased quantity exceeds stock availability, please allow 12 weeks for delivery.</p>
            </div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Ship To:</div>
            <div class="col-md-6 no-pr"><input type="text" class="form-control" placeholder="* Address" ref="shipping_address" v-model="model.shipping_address" :disabled="po_by_car"></div>
            <div class="col-md-3 no-pl">
                <select class="form-control" ref="shipping_country" @change="change_country('shipping')" v-model="model.shipping_country" :disabled="po_by_car">
                    <option value="">* Country</option>
                    <template v-if="!user || (user && (user.country == 'US' || user.country == 'USA'))">
                        <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                    </template>
                    <template v-else-if="user && user.country">
                        <option :value="user.country">{{ user.country }}</option>
                    </template>
                    <template v-else>
                        <option value="Canada">Canada</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Puerto Rico">Puerto Rico</option>
                        <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                        <option value="Cayman Islands">Cayman Islands</option>
                    </template>
                </select>
            </div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3"></div>
            <div class="col-md-3 no-pr"><input type="text" class="form-control" placeholder="* City" ref="shipping_city" v-model="model.shipping_city" :disabled="po_by_car"></div>
            <div class="col-md-3 no-pr no-pl">
                <template v-if="!states[model.shipping_country]">
                    <input key="ss_input" ref="shipping_state" type="text" class="form-control" placeholder="* State" v-model="model.shipping_state" :disabled="po_by_car">
                </template>
                <template v-else>
                    <select key="ss_select" ref="shipping_state" class="form-control" v-model="model.shipping_state" :disabled="po_by_car">
                        <option value="">* State</option>
                        <option v-for="state in states[model.shipping_country]" :key="state" :value="state">{{ state }}</option>
                    </select>
                </template>
            </div>
            <div class="col-md-3 no-pl"><input type="text" class="form-control" placeholder="* Zip" ref="shipping_zip" v-model="model.shipping_zip" :disabled="po_by_car"></div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Bill To:</div>
            <div class="col-md-6 no-pr"><input type="text" class="form-control" placeholder="* Address" ref="billing_address" v-model="model.billing_address"></div>
            <div class="col-md-3 no-pl">
                <select class="form-control" ref="billing_country" @change="change_country('billing')" v-model="model.billing_country">
                    <option value="">* Country</option>
                    <template v-if="!user || (user && (user.country == 'US' || user.country == 'USA'))">
                        <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                    </template>
                    <template v-else-if="user && user.country">
                        <option :value="user.country">{{ user.country }}</option>
                    </template>
                    <template v-else>
                        <option value="Canada">Canada</option>
                        <option value="Mexico">Mexico</option>
                        <option value="Puerto Rico">Puerto Rico</option>
                        <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                        <option value="Cayman Islands">Cayman Islands</option>
                    </template>
                </select>
            </div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3"></div>
            <div class="col-md-3 no-pr"><input type="text" class="form-control" placeholder="* City" ref="billing_city" v-model="model.billing_city"></div>
            <div class="col-md-3 no-pr no-pl">
                <template v-if="!states[model.billing_country]">
                    <input key="bs_input" ref="billing_state" type="text" class="form-control" placeholder="* State" v-model="model.billing_state">
                </template>
                <template v-else>
                    <select key="bs_select" ref="billing_state" class="form-control" v-model="model.billing_state">
                        <option value="">* State</option>
                        <option v-for="state in states[model.billing_country]" :key="state" :value="state">{{ state }}</option>
                    </select>
                </template>
            </div>
            <div class="col-md-3 no-pl"><input type="text" class="form-control" placeholder="* Zip" ref="billing_zip" v-model="model.billing_zip"></div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Shipping Type:</div>
            <div class="col-md-9">
                <select class="form-control" ref="shipping_type" v-model="model.shipping_type">
                    <option v-for="(shipping_type, key) in shipping_types" :key="key" :value="shipping_type.id">{{ shipping_type.name }}</option>
                </select>
            </div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Customer Carrier:</div>
            <div class="col-md-9"><input type="text" class="form-control" :disabled="model.shipping_type != 8" ref="customer_carrier" v-model="model.customer_carrier"></div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Cus. Shipping Acct#:</div>
            <div class="col-md-9"><input type="text" class="form-control" :disabled="model.shipping_type != 8" ref="customer_shipping_account" v-model="model.customer_shipping_account"></div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Shipping Contact Name:</div>
            <div class="col-md-9"><input type="text" class="form-control" ref="shipping_contact_name" v-model="model.shipping_contact_name" maxlength="100"></div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Shipping Contact Phone:</div>
            <div class="col-md-9"><input type="text" class="form-control" ref="shipping_contact_phone" v-model="model.shipping_contact_phone" maxlength="20"></div>
        </div>
        <div class="row input-wrap">
            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Shipping Contact Email:</div>
            <div class="col-md-9"><input type="text" class="form-control" ref="shipping_contact_email" v-model="model.shipping_contact_email" maxlength="100"></div>
        </div>
    </div>
</template>
<script>
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    components: { 
        DatePicker
    },
    data() {
        var date = new Date(),
            lead = ((14 * 7) - 1),
            lead_sw = ((4 * 7) - 1),
            max_days = ((25 * 7) - 1);
        let max_date = new Date(date);
        date.setDate(date.getDate() + lead);
        max_date.setDate(max_date.getDate() + max_days);

        return {
            lead: lead,
            lead_sw: lead_sw,
            settings: [],
            max_days: max_days,
            countries: window.countries,
            states: window.states,
            disabledBefore : date,
            disabledMaxDate: max_date,
            shipping_types: [
                { id: 0, name: 'Shipping Type*' },
                { id: 13, name: 'TDI Prepay - 24HR No Lift Gate' },
                { id: 2, name: 'TDI Prepay - 24Hr Lift Gate' },
                { id: 8, name: 'Customer Account' },
                { id: 9, name: 'Customer Pickup' }
            ],
            model: {
                validated: false,
                delivery_date: '',
                shipping_address: '',
                shipping_city: '',
                shipping_state: '',
                shipping_zip: '',
                shipping_country: '',
                billing_address: '',
                billing_city: '',
                billing_state: '',
                billing_zip: '',
                billing_country: '',
                shipping_type: 0,
                customer_carrier: '',
                customer_shipping_account: '',
                shipping_contact_name: '',
                shipping_contact_phone: '',
                shipping_contact_email: ''
            },
            user: {},
            customer_carrier: '',
            customer_shipping_account: ''
        }
    },
    props: {
        done: String,
        stype: String,
        customer_details: Object,
        po_by_car: {
            type: Boolean,
            default: false
        },
        backorder: {
            type: Boolean,
            default: false
        },
        spare: {
            type: Boolean,
            default: false
        },
        itemleadtime: {
            type: Object,
            default: () => ({
                has_item_lead_time: false,
                lead_time: 0
            })
        }
    },
    mounted() {
        let user = localStorage.getItem('user')
        if(!user) {
            this.shipping_types = [
                { id: 0, name: 'Shipping Type*' },
                { id: 8, name: 'Customer Account' },
                { id: 9, name: 'Customer Pickup' }
            ]
            this.model.shipping_type = 8
        }
        
        this.user = JSON.parse(user)

        this.loadSettings();

        let date = new Date()
        let leadt = this.spare && !this.backorder ? 1 : parseInt(this.user.lead_time);
        let lead = ((leadt * 7) - 1) //weeks to days
        date.setDate(date.getDate() + lead)

        this.lead = lead
        this.disabledBefore = date

        this.$emit('data', this.model)
    },
    watch: {
        'model.shipping_type'(n) {
            if(n == 8) {
                this.model.customer_carrier = this.customer_carrier
                this.model.customer_shipping_account = this.customer_shipping_account
            } else {
                this.model.customer_carrier = ''
                this.model.customer_shipping_account = ''
            }
        },
        'done'() {
            let errors = []
            let required = [
                'delivery_date',
                'shipping_address',
                'shipping_city',
                'shipping_state',
                'shipping_zip',
                'shipping_country',
                'billing_address',
                'billing_city',
                'billing_state',
                'billing_zip',
                'billing_country',
                'shipping_type',
                'shipping_contact_name',
                'shipping_contact_phone',
                'shipping_contact_email'
            ]

            if(this.po_by_car) {
                required = [
                    'billing_address',
                    'billing_city',
                    'billing_state',
                    'billing_zip',
                    'billing_country',
                    'shipping_type',
                    'shipping_contact_name',
                    'shipping_contact_phone',
                    'shipping_contact_email'
                ]
            }

            if(this.model.shipping_type == 8) {
                required.push('customer_carrier')
                required.push('customer_shipping_account')
            }
            
            required.forEach(element => {
                if(!this.model[element]) {
                    errors[element] = ['Required']
                }
            })

            if(Object.keys(errors).length > 0) {
                this.model.validated = false
            } else {
                this.model.validated = true
            }

            this.validation_error(errors)
            this.$emit('data', this.model)
        },
        'customer_details'(n) {
            if(Object.keys(n).length > 0) {
                if(n.cc_only == 1) {
                    this.shipping_types = [
                        { id: 0, name: 'Shipping Type*' },
                        { id: 8, name: 'Customer Account' },
                        { id: 9, name: 'Customer Pickup' }
                    ]
                    this.model.shipping_type = 8
                }
                if(n.customer_billing) {
                    this.model.billing_address = n.customer_billing.billing_address
                    this.model.billing_city = n.customer_billing.billing_city
                    this.model.billing_state = n.customer_billing.billing_state
                    this.model.billing_country = n.customer_billing.billing_country
                    this.model.billing_zip = n.customer_billing.billing_zip
                }
                if(n.has_disassembly) {
                    var date = new Date()
                    date.setDate(date.getDate() + 124)
                    this.disabledBefore = date
                }
                if(n.customer_account) {
                    this.customer_carrier = n.customer_account.customer_carrier
                    this.customer_shipping_account = n.customer_account.customer_shipping_account
                    if ( n.customer_account.shipping_type_id > 0 ) this.model.shipping_type = n.customer_account.shipping_type_id
                    if(this.model.shipping_type == 8) {
                        this.model.customer_carrier = this.customer_carrier
                        this.model.customer_shipping_account = this.customer_shipping_account
                    }
                    this.model.shipping_contact_email = n.customer_account.shipping_contact_email
                    this.model.shipping_contact_name = n.customer_account.shipping_contact_name
                    this.model.shipping_contact_phone = n.customer_account.shipping_contact_phone
                }
            }
        },
        'po_by_car'(n) {
            if(n) {
                this.model.delivery_date = ''
                this.model.shipping_address = ''
                this.model.shipping_city = ''
                this.model.shipping_state = ''
                this.model.shipping_zip = ''
                this.model.shipping_country = ''
            }
        },
        'backorder'(n) {
            if(n) {
                var date = new Date();
                var lead = this.stype == 'stock' ? this.lead_sw : this.lead;
                date.setDate(date.getDate() + lead)
                this.disabledBefore = date
                this.model.delivery_date = ''
            }
        },
        stype: {
            handler: function(data) {
                console.log('isstokk',data);
                if(data) {
                    var date = new Date();
                    var lead = (data == 'stock') ? this.lead_sw : this.lead;
                    date.setDate(date.getDate() + lead);
                    this.disabledBefore = date;
                    this.model.delivery_date = '';
                }
            }
        },
        'itemleadtime'(n) {
            if (n.has_item_lead_time) {
                if (n.lead_time > parseInt(this.user.lead_time) && n.lead_time > 4) { // 4 for lead_sw
                    let ltdate = new Date();
                    const ltlead = ((n.lead_time * 7) - 1);
                    ltdate.setDate(ltdate.getDate() + ltlead)
                    this.disabledBefore = ltdate
                    this.model.delivery_date = ''
                }
            }
        }
    },
    methods: {
        loadSettings() {
            this.$http.get('/api/data/settings').then((r) => {
                this.settings = r.data;

                if ( this.settings['stock_leadtime'] && this.settings['stock_leadtime'] > 0 ) {
                    this.lead_sw = (parseInt(this.settings['stock_leadtime']) * 7) - 1;

                    if ( this.stype == 'stock' ) {
                        let date = new Date();
                        date.setDate(date.getDate() + this.lead_sw)
                        this.disabledBefore = date
                        this.model.delivery_date = ''
                    }
                }
            });
        },
        change_country(type) {
            let states = this.states[this.model[`${type}_country`]]
            if(states != undefined) {
                let cur_state = this.model[`${type}_state`]
                this.model[`${type}_state`] = ''
                
                for(let key in states) {
                    if(states[key] == cur_state) {
                        this.model[`${type}_state`] = states[key]
                        break
                    }
                }
            }
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('#shipping-wrap .hasError')).forEach(function(el) { 
                el.classList.remove('hasError');
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.input-wrap {
    padding: 2px 10px;
}
.plabel {
    padding-top: 7px;
}
.no-pr {
    padding-right: 2px;
}
.no-pl {
    padding-left: 0;
}
.backorder_msg {
    color: #c90000;
    margin: 0;
}
@media (max-width: 768px) {
    .input-wrap {
        padding: 0;
    }
    .plabel {
        text-align: left !important;
    }
    .no-pr {
        padding-right: 15px;
    }
    .no-pl {
        padding-left: 15px;
    }
    .col-md-3, .col-md-6 {
        margin-bottom: 2px;
    }
}
</style>